import { render, staticRenderFns } from "./UserAvatarUpdate.vue?vue&type=template&id=0d167d35&"
import script from "./UserAvatarUpdate.vue?vue&type=script&lang=js&"
export * from "./UserAvatarUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports